import type { Bundle } from '../types'

/** Balayage mondial (N4) : marchands non déclarés et carte des résultats. */
export const webscan = {
  'webscan.runScan': { fr: 'Lancer un scan N4 :', en: 'Run a level-4 scan:' },
  'webscan.scanBtn': { fr: 'Lancer le scan', en: 'Run scan' },
  'webscan.scanRunning': { fr: 'Scan en cours…', en: 'Scan in progress…' },
  'webscan.allCountriesLabel': { fr: 'tous les pays', en: 'all countries' },
  'webscan.scanDone': {
    fr: 'Scan terminé — {total} résultat(s) trouvé(s) pour {label}',
    en: 'Scan complete — {total} result(s) found for {label}',
  },
  'webscan.scanError': { fr: 'Erreur : {error}', en: 'Error: {error}' },

  // Bandeau de couverture
  'webscan.coveragePartial': {
    fr: 'Couverture partielle du rapprochement',
    en: 'Partial matching coverage',
  },
  'webscan.coverageInactive': {
    fr: 'Rapprochement marchand × marque inactif',
    en: 'Merchant × brand matching inactive',
  },

  // Indicateurs
  'webscan.foundLabel': { fr: 'Non déclarés trouvés', en: 'Undeclared merchants found' },
  'webscan.foundSub': { fr: 'Utilisent vos moyens de paiement', en: 'Using your payment methods' },
  'webscan.countriesLabel': { fr: 'Pays touchés', en: 'Countries affected' },
  'webscan.countriesSub': { fr: 'Sur {n} pays surveillés', en: 'Out of {n} monitored countries' },
  'webscan.shownLabel': { fr: 'Résultats affichés', en: 'Results shown' },
  'webscan.scanStateLabel': { fr: 'Scan en cours', en: 'Scan running' },
  'webscan.scanActive': { fr: 'Balayage N4 actif', en: 'Level-4 sweep active' },
  'webscan.scanIdle': { fr: 'Aucun balayage actif', en: 'No sweep running' },

  // Carte
  'webscan.mapTitle': { fr: 'Carte mondiale des résultats N4', en: 'World map of level-4 results' },
  'webscan.legend6plus': { fr: '6 et plus', en: '6 and more' },
  'webscan.legend3to5': { fr: '3 à 5', en: '3 to 5' },
  'webscan.legend1to2': { fr: '1 à 2', en: '1 to 2' },
  'webscan.legendNone': { fr: 'Aucune', en: 'None' },
  'webscan.legendOutside': { fr: 'Hors périmètre', en: 'Out of scope' },
  'webscan.resetCountry': { fr: 'Réinitialiser le filtre pays', en: 'Clear country filter' },
  'webscan.mapUnavailable': {
    fr: 'Carte indisponible : la bibliothèque D3 n’a pas été chargée.',
    en: 'Map unavailable: the D3 library did not load.',
  },

  // Liste
  'webscan.resultsFor': { fr: 'Résultats — {country}', en: 'Results — {country}' },
  'webscan.allResults': { fr: 'Tous les résultats', en: 'All results' },
  'webscan.exportCsv': { fr: 'Exporter en CSV', en: 'Export to CSV' },
  'webscan.exportCsvTitle': {
    fr: 'Exporter les détections et leur état de traitement',
    en: 'Export the detections and their triage state',
  },
  'webscan.allBrands': { fr: 'Toutes marques', en: 'All brands' },
  'webscan.allActions': { fr: 'Toutes actions', en: 'All actions' },
  'webscan.worldwide': { fr: 'Mondial', en: 'Worldwide' },
  'webscan.uncategorised': { fr: 'Non classé', en: 'Uncategorised' },
  'webscan.knownMerchant': { fr: 'Marchand connu', en: 'Known merchant' },
  'webscan.authorizedFor': { fr: 'autorisé pour', en: 'authorised for' },
  'webscan.noBrandRegistered': { fr: 'aucune marque enregistrée', en: 'no brand registered' },
  'webscan.butNotFor': { fr: 'pas pour {brand}', en: 'not for {brand}' },
  'webscan.scoreLabel': { fr: 'Score {score}', en: 'Score {score}' },
  'webscan.emptyFiltered': { fr: 'Aucun résultat avec ces filtres.', en: 'No result matches these filters.' },
  'webscan.openInNewTab': { fr: 'Ouvrir {url} dans un nouvel onglet', en: 'Open {url} in a new tab' },
  'webscan.paginationInfo': {
    fr: 'Page {page} / {pages} — {total} résultats',
    en: 'Page {page} of {pages} — {total} results',
  },

  // Verdicts
  'webscan.action.ONBOARD': { fr: 'À onboarder', en: 'To onboard' },
  'webscan.action.INVESTIGATE': { fr: 'À investiguer', en: 'To investigate' },
  'webscan.action.BLOCK': { fr: 'À bloquer', en: 'To block' },
} satisfies Bundle
